import http from "src/_services/httpService";

import { $BASE_URL } from "src/constants";
const apiUrl = $BASE_URL + '/api';

const apiEndpoint = apiUrl + "/v1/notification"

const getNotifications = (page, limit) => {
    let url = `${apiEndpoint}?page=${page}`
    url += `&limit=${limit}`
    return http.get(url);
}

const updateNotificationsMultiOrders = (id) => {
    return http.get(`${$BASE_URL}/api/v1/merchant-dashboard/order?notification=${id}`);
}

const setNotificationSeen = id => {
    return http.put(`${$BASE_URL}/api/v1/notification/update`, {id});
}

const NotificationsService = {
    getNotifications,
    updateNotificationsMultiOrders,
    setNotificationSeen
};

export default NotificationsService;